<div class="container-fluid">
  <h5 class="text-success">Solicitação de Renúncia Limite Adicional</h5>
  <div class="container">
    <h5 class="text-success fw-bold mt-3" *ngIf="textoVigencia">{{ textoVigencia }}</h5>

    <p class="mt-2">
      Nos termos do artigo 16, § 13 e 15, e ANEXO XIV-A do Regulamento dos Programas de Garantia do PEAC,
      o Agente Financeiro informará a opção de alteração DO LIMITE ADICIONAL de garantia no formulário de solicitação.
    </p>

    <form [formGroup]="pesquisaForm" class="mt-3">
      <div class="d-flex align-items-center mb-3">
        <h3 class="mb-0" style="margin-right: auto;">Filtros de pesquisa</h3>
        <button type="button" class="btn btn-primary" style="margin-right: .5rem;" *ngIf="podeSolicitar"
          [disabled]="!janelaAtiva || !pesquisaForm.get('tranche').value || jaTemSolicitacao" (click)="irParaSolicitacao()">
          <i class="fas fa-hand-holding-usd"></i> Solicitação de Renúncia
        </button>
        <button type="button" class="btn btn-light" style="margin-right: .5rem;" (click)="limpar()">Limpar</button>
        <button type="button" class="btn btn-success" (click)="buscar()"
          [disabled]="!pesquisaForm.get('tranche').value">Pesquisar</button>
      </div>

      <div class="row">
        <div class="bn-form-group col-md-4">
          <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
          <ng-select id="agenteFinanceiro" class="auto-grow" [compareWith]="comparaComFuncao" 
            formControlName="agenteFinanceiro" 
            [items]="agentesFinanceiros" bindLabel="nome" placeholder="Todos">
              <ng-template ng-label-tmp let-item="item">{{ item.nome }}</ng-template>
              <ng-template ng-option-tmp let-item="item">{{ item.nome }}</ng-template>
          </ng-select>
        </div>

        <div class="bn-form-group col-md-2">
          <label class="form-label" for="tranche">Cesta:</label>
          <select id="tranche" class="form-select" formControlName="tranche">
            <option [ngValue]="''"></option>
            <option *ngFor="let tranche of tranches" [ngValue]="tranche.id">
              {{ tranche.numeroTranche }} ({{ tranche.dataInicioContratacao | date: 'dd/MM/yyyy' }})
            </option>
          </select>
        </div>

        <div class="bn-form-group col-md-3" *ngIf="pesquisaForm.get('tranche').value">
          <label class="form-label" for="limiteAdicional">Limite Adicional:</label>
          <select id="limiteAdicional" class="form-select" formControlName="limiteAdicional">
            <option [ngValue]="''">Todos</option>
            <option *ngFor="let limite of limitesAdicionais" [ngValue]="limite.ide">
              {{ limite.limiteAdicional }}
            </option>
          </select>
        </div>

        <div class="bn-form-group col-md-3" *ngIf="pesquisaForm.get('tranche').value">
          <label class="form-label" for="janela">Janela de Renúncia:</label>
          <select id="janela" class="form-select" formControlName="janela">
            <option [ngValue]="''">Todos</option>
            <option *ngFor="let janela of janelas" [ngValue]="janela.ide">
              {{ formatarJanelaLabel(janela) }}
            </option>
          </select>
        </div>
      </div>
    </form>
  </div>

  <app-renuncia-limite-adicional-listagem
    [renuncias]="renuncias" 
    (renunciaExcluida)="buscar()" 
    *ngIf="pesquisado">
  </app-renuncia-limite-adicional-listagem>
</div>